import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import classnames from 'classnames';
import { Button, Icon, IconSize } from '@sbt-web/ui';
import { Plus } from './Icons';
import { PhoneDialog } from './PhoneDialog';
import styles from './index.module.scss';
interface PhoneForwarderProps {
  phone?: string;
  onSetPhoneNumber: (phoneNumber: string) => void;
  isMobile: boolean;
}
interface RemoveButtonProps {
  isMobile: boolean;
  onClick: () => void;
}
const RemoveButton = t0 => {
  const $ = _c(3);
  const {
    isMobile,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isMobile || $[1] !== onClick) {
    t1 = isMobile ? <Button design="text" onClick={onClick} size="medium" icon={<Icon name="Bin" iconSize={IconSize.MD} />} aria-label="elimina numero" /> : <Button size="small" design="text" onClick={onClick}>Elimina numero</Button>;
    $[0] = isMobile;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const PhoneForwarder = t0 => {
  const $ = _c(15);
  const {
    phone,
    onSetPhoneNumber,
    isMobile
  } = t0;
  const [showPhoneDialog, setShowPhoneDialog] = useState(false);
  let t1;
  if ($[0] !== onSetPhoneNumber) {
    t1 = phoneNumber => {
      setShowPhoneDialog(false);
      onSetPhoneNumber(phoneNumber);
    };
    $[0] = onSetPhoneNumber;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handlePhoneDialogSubmit = t1;
  let t2;
  if ($[2] !== onSetPhoneNumber) {
    t2 = () => onSetPhoneNumber("");
    $[2] = onSetPhoneNumber;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleDeletePhoneNumber = t2;
  let t3;
  if ($[4] !== handleDeletePhoneNumber || $[5] !== isMobile || $[6] !== phone) {
    t3 = <div className={styles.marginTop}>{phone ? <><p className={classnames("body-text", "book", styles.recallText)}>Richiamami al {phone}<RemoveButton onClick={handleDeletePhoneNumber} isMobile={isMobile} /></p><p className={classnames("body-text", "book", styles.forwardText)}>Il tuo numero sarà inoltrato insieme al tuo messaggio</p></> : <Button design="outline" icon={<Plus />} onClick={() => setShowPhoneDialog(true)} size="small" type="button">Aggiungi telefono</Button>}</div>;
    $[4] = handleDeletePhoneNumber;
    $[5] = isMobile;
    $[6] = phone;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setShowPhoneDialog(false);
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== handlePhoneDialogSubmit || $[10] !== showPhoneDialog) {
    t5 = <PhoneDialog isOpened={showPhoneDialog} onClose={t4} onSubmit={handlePhoneDialogSubmit} />;
    $[9] = handlePhoneDialogSubmit;
    $[10] = showPhoneDialog;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};